import React, { useContext, useState, useEffect } from "react";

import { getConvertCurrency } from "../../api/exchangeApi";
import { CurrencyContext } from "../../context/currencyContext";
import { LangContext } from "../../context/langContext";
import { formatNumber } from "../../services/generalSevices";

export default function ItemCollaboration({ item }) {

    const { currency } = useContext(CurrencyContext);
    const auxCurrency = currency.symbol;
    const [itemPrice, setItemPrice] = useState(null);
    const { locale } = useContext(LangContext);

    useEffect(() => {
        getConvertCurrency({ amount: (item.price) * (item.quantity) }).then((response) => {
            //setItemPrice(response[auxCurrency].toFixed(0))
            setItemPrice(response[auxCurrency].toFixed(2))
        })

    }, [currency])

    return (
        <tr>
            <td><span className="itemName">{(locale === 'es-CO') ? JSON.parse(item.title).nombre : JSON.parse(item.title).name}</span> x {item.quantity}</td>
            <td>${formatNumber(itemPrice)}</td>
        </tr>
    )
}